import { FirebaseConfig } from './../environments/FirebaseConfig';
// Dependecies

// Components, services and pipes
import { BrowseListService } from './services/browse-list.service';
import { ProfileGuardService } from './services/profile-guard.service';
import { MyListService } from './services/my-list.service';
import { ProfileComponent } from './ui/profile/profile.component';
import { BrowseComponent } from './ui/browse/browse.component';
import { AuthService } from './services/auth.service';
import { AppComponent } from './app.component';
import { NavbarComponent } from './ui/navbar/navbar.component';
import { GameComponent } from './ui/game/game.component';
import { CreateFokoComponent } from './ui/create-foko/create-foko.component';
import { NavbarService } from './services/navbar-service.service';
import { MyFokosComponent } from './ui/my-fokos/my-fokos.component';
import { LoginComponent } from './ui/login/login.component';
import { ResetPasswordComponent } from './ui/reset-password/reset-password.component';
import { CapitalizePipe } from './extra/capitalize.pipe';
import { ShareFokoDialogComponent } from './ui/dialogs/share-foko-dialog/share-foko-dialog.component';
import { NotFoundComponent } from './ui/not-found/not-found.component';

// angular
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

// firebase
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';

// Angular Material
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule, MatDialogModule} from '@angular/material';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';

// Other
import {InfiniteScrollModule} from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    MyFokosComponent,
    BrowseComponent,
    ProfileComponent,
    LoginComponent,
    GameComponent,
    NotFoundComponent,
    CreateFokoComponent,
    CapitalizePipe,
    ResetPasswordComponent,
    ShareFokoDialogComponent
  ],
  entryComponents: [
    ShareFokoDialogComponent,
    NotFoundComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    InfiniteScrollModule,
    AngularFireModule.initializeApp(FirebaseConfig),
    AngularFireDatabaseModule,
    MatStepperModule,
    MatSnackBarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    RouterModule.forRoot([
      { path: '', component: MyFokosComponent },
      { path: 'browse', component: BrowseComponent },
      { path: 'create-foko', component: CreateFokoComponent },
      { path: 'profile', component: ProfileComponent, canActivate: [ProfileGuardService] },
      { path: 'login', component: LoginComponent },
      { path: 'reset', component: ResetPasswordComponent },
      { path: 'game/:accessType/:key', component: GameComponent},
      { path: '**', component: NotFoundComponent } // Needs to be last
    ])
  ],
  providers: [
    AuthService, AngularFireAuth, MyListService, ProfileGuardService, BrowseListService, NavbarService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/app.module.ts